var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4409 8.8817C4.28137 8.8817 4.1218 8.82066 4.00028 8.69911L0.182832 4.88157C-0.0609439 4.63791 -0.0609439 4.24397 0.182832 4.00031C0.42649 3.75665 0.820317 3.75665 1.06409 4.00031L4.4409 7.37712L11.6354 0.182744C11.879 -0.0609146 12.2729 -0.0609146 12.5166 0.182744C12.7603 0.426519 12.7603 0.820376 12.5166 1.06412L4.88163 8.69911C4.76011 8.82066 4.60043 8.8817 4.4409 8.8817Z",
    fill: "#16A94D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.f90cdc79f65da02b6541b55f3f7b35ac.svg";
export { ForwardRef as ReactComponent };